<template>
  <div class="cp-hp_banner">
    <!-- <div class="debugger"></div>-->
    <div class="banner-container">
      <div class="banner-text-area">
        <div class="wrap text-center mb-3">
          <h1 class="hero d-none d-sm-block">
            {{ cpLang('homepage.hero_h1') }}
          </h1>
          <h3 class="hero-subtitle d-none d-sm-block">
            {{ cpLang('homepage.hero_h3') }}
          </h3>
          <h4 v-if="!isMobile" class="mb-0 mb-sm-2 mb-xl-0 find-txt">
            {{ cpLang("homepage.find_dream") }}
          </h4>
          <div v-if="isMobile">
            <img src="/asset/image/logo/m-logo-getlinks.png" class="img-fluid home-icon">
            <h1 class="mb-0 mb-sm-2 mb-xl-0 hero">
              {{ cpLang('homepage.hero_h1') }}
            </h1>
            <h3 class="mb-0 mb-sm-2 mb-xl-0 hero-subtitle">
              {{ cpLang('homepage.hero_h3') }}
            </h3>
          </div>
        </div>

        <div class="input-wrap row">
          <div class="col-xs-12 col-md-9 col-lg-10 input-col">
            <SearchBox :is-mobile="isMobile" @search="goSearch" redirect recent-outside is-home-page />
          </div>
          <div v-if="!isMobile" class="col-xs-12 col-md-3 col-lg-2 pr-0">
            <div @click="goSearch" class="search-btn">
              {{ cpLang("global.search") }}
            </div>
          </div>
        </div>
        <SearchInput v-if="!isMobile" :d-industry="dIndustry" :d-jobfunction="dJobfunction" />
      </div>
    </div>
    <img src="/asset/image/bg/curve-graphic.svg" class="footer-mask">
  </div>
</template>
<script>
import SearchBox from '../search/SearchBox'
import SearchInput from './SearchInput'

export default {
  name: 'HomeBanner',
  components: {
    SearchBox,
    SearchInput
  },
  props: {
    dIndustry: {
      type: [Array, Object],
      default: null
    },
    dJobfunction: {
      type: [Array, Object],
      default: null
    },
    isMobile: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      industry: null,
      jobfunction: null,
      showTab: '',
      indText: '',
      jobText: ''
    }
  },
  mounted() {
    const vm = this
    const node = document.querySelector('#hp-keyword')
    if (node) {
      node.addEventListener('keyup', function (event) {
        if (event.key === 'Enter') {
          vm.goSearch()
        }
      })
    }
  },
  methods: {
    closeTab(e) {
      e.preventDefault()
      this.showTab = ''
    },
    goSearch: function() {
      const val = document.querySelector('#keyword').value
      window.location = '/SearchJobs?keyword=' + val
    }
  }
}
</script>

<style lang="scss">
.fa-chevron-down, .fa-chevron-up{
  color: #999 !important;
}
.banner-container{
  width: 100%;
  z-index: 25;
}
.home-icon{
  max-width: 150px;
  margin-top: 10vh;
  margin-bottom: 6vh;
}
.banner-text-area{
  .input-wrap{
    padding-left: 15px;
  }
  h4{
    font-size:22px;
    font-weight: bold;
  }
}
.search-wrap{
  position: sticky;
  top: 0;
  z-index: 20;
  width: 100%;
  margin: auto;
  padding: 0 27px;
  .fa-search{
    position: absolute;
    left: 32px;
    top: 10px;
    color: #ddd;
  }
}
h1{
  &.hero{
    font-size:2.5vw !important;
    color:#00CDA7 !important;
    line-height: 38px;
    font-weight: 600;
    padding:0rem 0 3rem;
    @media screen and (max-width: 568px) {
      font-size:18px !important;
      padding:0rem 0 0rem;
    }
  }
}
h3{
  &.hero-subtitle{
    font-size: 25px !important;
    color: #fff !important;
    padding-bottom: 70px;
    @media screen and (max-width: 568px) {
      font-size:14px !important;
      padding:1rem 0 0rem;
      font-weight: 600;
    }
  }
}
.search-btn {
  cursor: pointer;
  text-align: center;
  display: inline-block;
  padding: 9px 0px;
  background: linear-gradient(90deg, #0081BE,#00CDA7);
  border-radius: 31px;
  letter-spacing: 0;
  color: #FFFFFF;
  width: 100%;
  font-size: 16px;
}
.browse-jobs{
  color:#2B59C3;
  cursor: pointer;
}
.cp-hp_banner{
  position: relative;
  // overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  flex-flow: column;
  #search-box{
    border-radius: 20px;
  }
}
.cp-hp_appendix{
  text-align: center;
  margin: 0 auto;
  display: inline-block;
  width: 100%;
  .display-area{
    background: transparent;
  }
}
.container-fluid{
  &.list-wrap{
    height: 0;
    background:#EFF5F8;
    position: relative;
    &.wrap{
      .container{
        &.position-relative{
          position: absolute !important;
          left: 0;
          top: 0;
          background: #f0f0f0;
          width: 100%;
          max-width: 100%;
          height: 600px;
        }
      }
    }
  }
}
.close-wrap-btn{
  position: absolute;
  right: 10px;
  top: 0px;
  z-index: 99;
  cursor: pointer;
}
.clickable{
  &:hover{
    color: #000;
  }
}
.mouse-icon{
  position: absolute;
  z-index: 2;
  width: 100%;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  img{
    cursor: pointer;
    padding-top: 8px;
    max-width: 35px;
  }
  small{
    color: #fff;
    font-size: 12px;
  }
  i{
    font-size: 17px;
    color: #fff;
  }
}
.collaspe-wrap{
      position: relative;
    display: block;
    width: 100%;
    padding: 0px 27px;
    z-index: 10;
}
.search-filt{
  .col-6{
    border-radius: 20px;
  }
  .card{
    border-radius: 20px;
  }
  .card-header{
    background-color:#fff !important;
    border:0;
    border-radius: 20px;
    &:focus-visible{
      outline: 0 !important;
    }
  }
  button{
    background: #fff;
    border-radius: 20px;
    border: 0;
    color: #707070;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding:5px 20px;
    box-shadow:0 0 0 #fff!important;
    &:hover{
      background:#fff;
      color: #707070;
    }
    &:focus-visible{
      outline: 0 !important;
    }
    &:active, &:focus{
      background-color: #fff !important;
      outline: 0 !important;
      border-color: #fff !important;
      box-shadow: 0 !important;
    }
  }
  li{
    font-size: 14px;
    a{
    color:#707070;
      &:hover{
        color: #0EA5BF;
      }
    }
  }
  input{
    padding:5px 0px;
    width: 100%;
    border:0;
    border-bottom:1px solid #bbb;
    position: relative;
    &:focus-visible{
      outline: 0 !important;
    }
  }
  .result-wrap{
    border-radius: 20px;
    max-height: 390px;
    overflow: hidden;
    overflow-y: scroll;
    box-shadow: 0px 3px 2px #00000029;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
#showArd1{
  height:auto;
  transition: all .5s;
  // height:auto;
  max-height: 0;
  &.show{
    max-height: 450px;
  }
}
#showArd2{
  height:auto;
  transition: all .5s;
  // height:auto;
  max-height: 0;
  &.show{
    max-height: 450px;
  }
}
.find-txt{
  font-size:22px;
}
</style>
